import { isNowOrPast } from '@fora-monorepo/date-utils';
import { EmploymentViewModel, Markup, UpdateEmploymentOldInput } from '@fora-monorepo/employer-my-pages-common/types';

export const mockUpdateEmploymentOld = (
  unchangedEmployment: EmploymentViewModel,
  updateEmploymentInput: UpdateEmploymentOldInput
): EmploymentViewModel => {
  const markups: Markup[] = unchangedEmployment.markups;
  if (updateEmploymentInput.markup)
    markups.push({
      fokId: updateEmploymentInput.markup.fokId,
      startDate: updateEmploymentInput.markup.startDate,
      fokText: 'mockFokText',
      endDate: null,
      fokParameterChoices: [],
    });

  return {
    foraAgreementNumber: unchangedEmployment.foraAgreementNumber,
    policyNumber: unchangedEmployment.policyNumber,
    employmentStartDate: unchangedEmployment.employmentStartDate,
    employmentEndDate: updateEmploymentInput.markup?.endDate || unchangedEmployment.employmentEndDate,
    employee: {
      employeeId: updateEmploymentInput.employeeId,
      partnerNumberIndividual: unchangedEmployment.employee.partnerNumberIndividual,
      identificationType: updateEmploymentInput.identificationType,
      firstName: updateEmploymentInput.firstName,
      lastName: updateEmploymentInput.lastName,
      birthDate: unchangedEmployment.employee.birthDate,
      deathDate: unchangedEmployment.employee.deathDate,
      isVerified: unchangedEmployment.employee.isVerified,
      address: {
        coAddress: updateEmploymentInput.addressInfo?.coAddress,
        streetAddress: updateEmploymentInput.addressInfo?.streetAddress ?? '',
        streetAddress2: updateEmploymentInput.addressInfo?.streetAddress2 ?? '',
        postalCode: updateEmploymentInput.addressInfo?.postalCode,
        city: updateEmploymentInput.addressInfo?.city ?? '',
        countryCode: updateEmploymentInput.addressInfo?.countryCode ?? '',
      },
    },
    employmentPeriods: [],
    markups,
    activeMarkup:
      updateEmploymentInput.markup && isNowOrPast(updateEmploymentInput.markup.startDate)
        ? {
            ...updateEmploymentInput.markup,
            fokText: 'mockFokText',
            endDate: null,
            fokIsExpiring: null,
            fokParameterChoices: updateEmploymentInput.markup.fokParameterChoices.map(p => ({
              ...p,
              startDate: updateEmploymentInput.markup?.startDate || '',
              endDate: p.endDate || null,
            })),
          }
        : null,
    hasFokParameterChoices: updateEmploymentInput.markup?.fokParameterChoices
      ? updateEmploymentInput.markup?.fokParameterChoices?.length > 0
      : false,
    isInactive: false,
  };
};
